<template>
  <v-card
    :to="link"
    hover
    flat
    class="dashboard-card"
    :style="{ 'border-color': color }"
  >
    <div class="pa-4 d-flex justify-space-between">
      <div class="flex-grow-1">
        <div class="text-body-1 text--secondary">{{ title }}</div>
        <div v-if="headlineData !== null && headlineData !== undefined && headlineData !== ''" class="headline-data">{{ headlineData }}</div>
        <div v-if="headlineText" class="headline-text">{{ headlineText }}</div>
        <div class="text-body-2 text--secondary">{{ subText }}</div>
      </div>
      <div class="flex-grow-1 d-flex align-center justify-center">
        <v-icon
          :color="color"
          :style="{ 'background-color': colorLight }"
          large
          class="icon"
        >
          {{ iconText }}
        </v-icon>
      </div>
    </div>
  </v-card>
</template>

<script>
// @ is an alias to /src
export default {
  name: "DashboardCard",
  data: () => ({}),
  props: {
    title: {
      type: String,
      default: "",
    },
    headlineData: {
      type: [String, Number],
      default: "",
    },
    headlineText: {
      type: String,
      default: "",
    },
    subText: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "#0059a3",
    },
    colorLight: {
      type: String,
      default: "#cbe7ff",
    },
    iconText: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
  },
  mounted() {},
  methods: {},
  watch: {},
};
</script>

<style scoped>
.dashboard-card {
  border-style: solid;
  border-width: 1px;
  border-left-width: 6px;
  border-top-color: #e0e0e0 !important;
  border-bottom-color: #e0e0e0 !important;
  border-right-color: #e0e0e0 !important;
  border-radius: 10px;
  min-height: 125px;
}

.theme--dark .dashboard-card {
  border-top-color: #444 !important;
  border-bottom-color: #444 !important;
  border-right-color: #444 !important;
  background-color: #1e1e2e;
}

.headline-data {
  font-size: 32px;
  font-weight: 500;
  min-height: 48px;
}

.headline-text {
  font-size: 24px;
  font-weight: 500;
  min-height: 48px;
}

.icon {
  border-radius: 50%;
  padding: 10px;
}
</style>
